import { supabase } from '@/integrations/supabase/supabase';

const fromSupabase = async (query) => {
  const { data, error } = await query;
  if (error) throw new Error(error.message);
  return data;
};

export const fetchProfileFromAuthUserId = async (user_id) => {
  return await fromSupabase(
    supabase
      .from('profiles')
      .select(`*`)
      .eq('id', user_id)
      .single()
  );
};
